import ResetUpdatePassComponent from './../../../../Components/AdminComponents/Auth/ResetPassword/UpdatePassword/updatePassword';

const ResetUpdatePassContainer = () => {
  return <ResetUpdatePassComponent />;
};
export default ResetUpdatePassContainer;
